import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, take } from 'rxjs';

import { ProductTreeActionsItem } from '../models/productTreeActions.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductTreeActionsService {
  constructor(private httpClient: HttpClient) {}

  queryProductTreeActions(id: string | null, addProductContext: string | null): Observable<ProductTreeActionsItem[]> {
    if (addProductContext)
      return this.httpClient
        .get<ProductTreeActionsItem[]>(`${environment.apiUrl}/products/${id}/treeActions/${addProductContext}`)
        .pipe(take(1));
    else return this.httpClient.get<ProductTreeActionsItem[]>(`${environment.apiUrl}/products/${id}/treeActions`).pipe(take(1));
  }
}
